import React, { useEffect, useState, useRef, useCallback } from "react";
import { getPortfolioData } from "../../data/portfolioData";
import "./Projects.css";


const Projects = () => {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);
  const { slides, events, keywords } = getPortfolioData();


  const getSlideClass = (index) => {
    if (index === current) return "active";
    if (index === (current - 1 + slides.length) % slides.length) return "left";
    if (index === (current + 1) % slides.length) return "right";
    return "behind";
  };

  const showNext = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, [slides.length]);

  const showPrev = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const startAutoSlide = useCallback(() => {
    intervalRef.current = setInterval(showNext, 5000);
  }, [showNext]);

  const stopAutoSlide = useCallback(() => {
    clearInterval(intervalRef.current);
  }, []);

  const separator = " ── ⋆⋅☆⋅⋆ ── "; // you can change it to "|" or "—" or emojis like "✨"

    const [popupImage, setPopupImage] = useState(null);

  const openPopup = (src) => {
    setPopupImage(src);
  };

  const closePopup = () => {
    setPopupImage(null);
  };


  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, [startAutoSlide, stopAutoSlide]);

  return (
    <div>
      <section className="projects-section" id="resume">
        <h2 className="section-title">
          My Projects
        </h2>

        <div className="carousel">
          <button className="nav-btn left-btn" onClick={showPrev}>❮</button>

          {slides.map((slide, index) => (
            <div
              key={index}
              className={`slide-container ${getSlideClass(index)}`}
              onClick={() => window.open(slide.link, "_blank")}
            >
              <img src={slide.src} alt={slide.title} />
              <div className="tooltip">
                <h3>{slide.title}</h3>
                <p className="tech">{slide.tech.join(" • ")}</p>
                <p className="desc">{slide.description}</p>
              </div>
            </div>
          ))}

          <button className="nav-btn right-btn" onClick={showNext}>❯</button>
        </div>

        <marquee className="professional-marquee" behavior="scroll" direction="left" scrollamount="16">
          {keywords.map((keyword, index) => (
            <span key={index}>
              {keyword}
              {index !== keywords.length - 1 ? separator : ""}
            </span>
          ))}
        </marquee>
      </section>

    <section className="events-section" id="resume">
      <h2 className="section-title">
        My Events
      </h2>

      <div className="events-container">
        {events.map((event, index) => (
          <div className="event-card" key={index}>
            <img
              src={event.src}
              alt={event.title}
              className="event-image"
              onClick={() => openPopup(event.src)}
            />
            <h3 className="event-title">{event.title}</h3>
            <p className="event-description">{event.description}</p>
          </div>
        ))}
      </div>

      {/* Popup overlay */}
      {popupImage && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <img src={popupImage} alt="popup" />
            <span className="popup-close" onClick={closePopup}>
              &times;
            </span>
          </div>
        </div>
      )}
    </section>
    </div>

  );
};

export default Projects;
